/// <reference path="highcharts/highcharts.js"/>
/// <reference path="highcharts/exporting.js"/>
/// <reference path="LayoutDesigner.js"/>
/// <reference path="GuiEvents.js"/>
/// <reference path="Constants.js"/>
/// <reference path="HighchartsHelpers.js" />

/* Highcharts wrapper */
(function (sb) {
    var chartHandlers = [];
    var defaultStyles;
    var decimalSeparator;
    var thousandSeparator;

    var defaultChartTypeSettings = {
        bar: {
            borderColor: '#ffffff',
            dataLabels: {
                align: 'right'
            },
            animation: false,
            border: 1
        },
        column: {
            borderColor: '#ffffff',
            dataLabels: {
                align: 'right'
            },
            animation: false,
            border: 1
        },
        gauge: {
            dataLabels: {
                borderWidth: 0
            }
        },
        solidgauge: {
            dataLabels: {
                borderWidth: 0,
                verticalAlign: 'bottom'
            },
            colorByPoint: false
        },
        line: {
            animation: false,
            marker: {
                enabled: false
            }
        },
        pie: {
            showInLegend: true,
            allowPointSelect: false,
            animation: false
        },
        treemap: {
            dataLabels: {
                formatter: dataLabelFormatter
            },
            drillUpButton: {
                text: "⇠",
                position: {
                    align: 'left',
                    verticalAlign: 'top',
                    x: 10,
                    y: 10
                },
                theme: {
                    fill: '#f8f8f8',
                    'stroke-width': 1,
                    stroke: '#a0a0a0',
                    r: 4,
                    states: {
                        hover: {
                            fill: '#ffffff',
                            stroke: '#a0a0a0'
                        }
                    },
                    style: {
                        fontSize: '18px',
                        color: '#65737b'
                    }
                }
            },
        },
        series: {
            animation: false,
            showInLegend: true,
            shadow: true,
            marker: {
                enabled: false
            },
            pointPadding: 0.1,
            groupPadding: 0.2,
            dataLabels: {
                allowOverlap: true,
                //just for now, since hc is drawing labels with same color as the element
                align: 'center',
                color: '#000000',
                style: {
                    fontSize: '10px',
                    fontWeight: 'normal',
                    textShadow: 'none'
                },
                formatter: dataLabelFormatter
			},
			point: {
				events: {
					mouseOver: function () {
						var color = this.color || this.series.color;
						if (color && color != 'transparent' && color != 'rgba(255, 255, 255, 0.1)')
							this.pointAttr.hover.fill = HTMLHelpers.getPointHoverColor(color);
						if (this.guid && this.graphic) {
							this.graphic.attr({ cursor: 'pointer' });
							this.graphic.attr({ style: { cursor: 'pointer' } });
						}
					}
				}
			}
        },
        scatter: {
            dataLabels: {
                verticalAlign: 'middle'
			},
            marker: {
                enabled: true,
                radius: 5
            }
        }
    };

    function setDefaultOptions(isRTLCharsXAxis, isRTLCharsLegend) {
        var axisStyle = {};
        var legendStyle = {};

        var defaultStyle = {
            fontSize: '9px',
            color: '#000000'
        };

        $.extend(axisStyle, defaultStyle, { fontSize: '10px', fontWeight: 'normal', direction: isRTLCharsXAxis ? 'rtl' : 'ltr' });
        $.extend(legendStyle, defaultStyle, { fontSize: '10px', fontWeight: 'normal', direction: isRTLCharsLegend ? 'rtl' : 'ltr' });

		if (window.ContentType == Storyboard.Constants.itemTypes.CHART)
			$.extend(legendStyle, { cursor: 'default' });

        var defaultTheme = {
            chart: {
                style: defaultStyle,
                animation: false,
                backgroundColor: '#ffffff',
                borderColor: '#ffffff',
                borderRadius: 0,
                borderWidth: 0,
                plotBackgroundColor: '#ffffff',
                plotBorderColor: '#ffffff',
                plotBorderWidth: 1,
                shadow: false,
                guid: '',
                resetZoomButton: {
                    position: {
                        align: 'left',
                        x: 10,
                        y: 2
                    },
                    relativeTo: 'chart',
                    theme: {
                        height: 13
                    }
                }
            },
            credits: {
                enabled: false
            },

            plotOptions: defaultChartTypeSettings,

            exporting: {
                enabled: false,
                url: '',
                buttons: {
                    printButton: {
                        enabled: false
                    },
                    contextButton: {
                        enabled: false
                    },
                    exportButton: {
                        menuClassName: 'highcharts-export-menu',
                        _titleKey: 'exportButtonTitle',
                        backgroundColor: 'rgba(255, 255, 255, 0)',
                        borderColor: 'rgba(255, 255, 255, 0)',
                        symbolFill: 'rgba(255, 255, 255, 0)',
                        symbolStroke: 'rgba(255, 255, 255, 0)',
                        x: -10,
                        y: -28
                    }
                }
            },
            navigation: {
                menuStyle: {
                    background: '#f8f8f8',
                    cursor: 'default'
                },
                menuItemStyle: {
                    padding: '2',
                    background: 'transparent'
                },
                menuItemHoverStyle: {
                    background: 'transparent'
                }
            },
            legend: {
                itemStyle: legendStyle,
                backgroundColor: 'rgba(255, 255, 255, 0.001)',
                borderColor: 'rgba(255, 255, 255, 0.001)',
                symbolWidth: 8,
                borderRadius: 0,
                borderWidth: 0,
                floating: false,
                shadow: false,
                itemDistance: 10,
                useHTML: isRTLCharsLegend
            },
            lang: {
                exportButtonTitle: 'Show chart options',
                thousandsSep: thousandSeparator,
                decimalPoint: decimalSeparator
            },
            yAxis: {
                alternateGridColor: 'rgba(255, 255, 255, 0.001)',
                gridLineColor: 'rgba(255, 255, 255, 0.001)',
                gridLineDashStyle: 'ShortDot',
                gridLineWidth: 0,
                lineColor: '#c0d0e0',
                lineWidth: 1,
                startOnTick: true,
                endOnTick: true,
                showLastLabel: true,
                showFirstLabel: true,
                labels: {
                    rotation: 0,
                    style: axisStyle,
                    formatter: function (d) {
                        var opt = this.axis.options;
                        var value = this.value;
                        var seriesType = this.chart.series.length > 0 ? this.chart.series[0].userOptions.type : "";
                        //toFixed(value) in chrome,ie supports values 0-20. Firefox can handle more but this value will not be shown in charts type: "line, spline"
                        if (seriesType !== "heatmap" && !isNaN(value) && decimalPlaces(value) >= 0 && decimalPlaces(value) <= 20)
                            value = Highcharts.numberFormat(value, decimalPlaces(value), decimalSeparator, opt.showThousandSeparator ? thousandSeparator : "");

                        return ((opt.showUnitOnYAxis || opt.showUnitOnYaxis) && opt.unitPrefix || '') + value + ((opt.showUnitOnYAxis || opt.showUnitOnYaxis) && opt.unitSuffix || '');
                    }
                },
                title: {
                    style: defaultStyle
                }
            },
            xAxis: {
                alternateGridColor: 'rgba(255, 255, 255, 0.001)',
                gridLineColor: 'rgba(255, 255, 255, 0.001)',
                gridLineDashStyle: 'ShortDot',
                gridLineWidth: 0,
                lineColor: '#c0d0e0',
                lineWidth: 1,
                rotation: 0,
                labels: {
                    style: axisStyle,
                    useHTML: isRTLCharsXAxis,
                    formatter: function () {
                        var opt = this.axis.options;
                        var value = this.value;
                        if (this.chart) {
                            // xAxis is a value axis only in scatter/bubble
                            var seriesType = this.chart.series.length > 0 ? this.chart.series[0].userOptions.type : "";
                            if (seriesType == "scatter" && !isNaN(value) && decimalPlaces(value) >= 0 && decimalPlaces(value) <= 20)
                                value = Highcharts.numberFormat(value, decimalPlaces(value), decimalSeparator, opt.showThousandSeparator ? thousandSeparator : "");
                        }
                        return ((opt.showUnitOnYAxis || opt.showUnitOnYaxis) && opt.unitPrefix || '') + value + ((opt.showUnitOnYAxis || opt.showUnitOnYaxis) && opt.unitSuffix || '');
                    }
                },
                title: {
                    style: defaultStyle
                }
            },
            tooltip: {
                formatter: tooltipFormatter,
                style: {
                    "fontSize": "10px"
                }
			},
			title: {
				style: defaultStyle
			}
        };
        defaultStyles = defaultTheme;

        Highcharts.setOptions(defaultStyles);
        // use old default values (highcharts 3.something)
        Highcharts.Axis.prototype.defaultLeftAxisOptions.labels.x = -8;
        Highcharts.Axis.prototype.defaultRightAxisOptions.labels.x = 8;
        Highcharts.Axis.prototype.defaultBottomAxisOptions.labels.y = 14;
        Highcharts.Axis.prototype.defaultTopAxisOptions.labels.y = -5;

        /**
         * Extend drawDataLabels with logic to handle custom options related to the treemap series:
         * - Width of the dataLabel is set to match the width of the point shape.
         */
        Highcharts.seriesTypes.treemap.prototype.drawDataLabels = function () {
            var series = this,
                dataLabelsGroup = series.dataLabelsGroup,
                points = series.points,
                options,
                level;
            Highcharts.each(points, function (point) {
                level = series.levelMap[point.level];
                // Set options to new object to avoid problems with scope
                options = { style: {} };

                // If not a leaf, then label should be disabled as default
                if (!point.isLeaf) {
                    options.enabled = false;
                }

                // If options for level exists, include them as well
                if (level && level.dataLabels) {
                    options = Highcharts.merge(options, level.dataLabels);
                    series._hasPointLabels = true;
                }

                // Set dataLabel width to the width of the point shape.
                if (point.shapeArgs) {
                    options.style.width = point.shapeArgs.width;
                    options.style.textAnchor = 'middle';
                }

                // Merge custom options with point options
                point.dlOptions = Highcharts.merge(options, point.options.dataLabels);
            });

            this.dataLabelsGroup = this.group; // Draw dataLabels in same group as points, because of z-index on hover
            Highcharts.Series.prototype.drawDataLabels.call(this);
            this.dataLabelsGroup = dataLabelsGroup;
        };

        Highcharts.wrap(Highcharts.seriesTypes.treemap.prototype, 'alignDataLabel',
            function (proceed, point, dataLabel, options, alignTo, isNew) {
                // Apply the original function with the original arguments
                proceed.apply(this, Array.prototype.slice.call(arguments, 1));

                // Center align text after original function
                if (isNew) {
                    dataLabel.paddingLeftSetter((dataLabel.width - (dataLabel.padding * 2)) / 2);
                }
            }
        );
    }
    var decimalPlaces = function () {
        return function (n) {
            var decimalsPart = n.toString().split(".")[1];
            return (typeof decimalsPart === "undefined") ? 0 : decimalsPart.length;
        };
    }();

    function dataLabelFormatter() {
        var labelValues = [];
        var pointVals = [];

        // pie probably wont have any axes...
        var xAxisOpt = !this.series.xAxis ? {} : this.series.xAxis.options;
        var yAxisOpt = !this.series.yAxis ? {} : this.series.yAxis.options;

        // pie isn't associated with any axis, but the chart still has one that we can retrieve
        if (this.series.type == "pie")
            yAxisOpt = this.series.chart.yAxis[0].options;

        if (this.point.showValues) {
            // pushing point values into a separate array so we can join them with ";" in between
            if (this.point.series.type == "scatter") {
                var px = this.point.sx;
                if (xAxisOpt.unitPrefix && this.point.showXUnitText)
                    px = xAxisOpt.unitPrefix + px;
                else if (xAxisOpt.unitSuffix && this.point.showXUnitText)
                    px = px + xAxisOpt.unitSuffix;
                pointVals.push(px);
            }

            if (this.point.value != null
                && this.point.formattedValue !== '') {

                var po = this.point.options;
                var pv = this.point.formattedValue;
                //toFixed(value) in chrome,ie supports values 0-20. Firefox can handle more but this value will not be shown in charts type: "line, spline"
                if (!isNaN(pv) && decimalPlaces(pv) >= 0 && decimalPlaces(pv) <= 20)
                    pv = Highcharts.numberFormat(pv, decimalPlaces(pv), decimalSeparator, po.showThousandSeparator ? thousandSeparator : "");

                if (po.showPositivePrefix && parseFloat(pv) >= 0)
                    pv = "+" + pv;

                if (this.point.series.type == "treemap") {
                    if (po.unit) {
                        if (po.unit.unitPlacement === sb.Constants.SeriesUnitPlacement.Prefix)
                            pv = po.unit.unitText + pv;
                        else if (po.unit.unitPlacement === sb.Constants.SeriesUnitPlacement.Suffix)
                            pv = pv + po.unit.unitText;
                    }

                    pv = this.point.id ? ('| ' + pv) : ('<br/>' + pv + '<br/>');
                } else if (this.point.series.type == "heatmap") {
                    if (yAxisOpt.unitPrefix && this.point.showYUnitText)
                        pv = yAxisOpt.unitPrefix + pv;
                    else if (yAxisOpt.unitSuffix && this.point.showYUnitText)
                        pv = pv + yAxisOpt.unitSuffix;
                }


                pointVals.push(pv);
            } else if (this.y != null) {
                var py = this.point.sy;
                if (yAxisOpt.unitPrefix && (this.point.showYUnitText || this.point.showYunitText))
                    py = yAxisOpt.unitPrefix + py;
                else if (yAxisOpt.unitSuffix && (this.point.showYUnitText || this.point.showYunitText))
                    py = py + yAxisOpt.unitSuffix;

                pointVals.push(py);
            }

            if (this.point.series.type == "scatter" && this.point.z != null) {
                var pz = this.point.sz;
                pointVals.push(pz);
            }
        }

        if (this.point.series.type == "treemap" && this.point.name)
            labelValues.push(this.point.name);
        else if (this.point.lname)
            labelValues.push(this.point.lname);

		labelValues.push(pointVals.join("; "));

		if (this.point.referenceDiff) {
			labelValues.push(this.point.referenceDiff);
		}

        if (this.point.benchmarkY && this.point.benchmarkY.length > 0)
            labelValues.push("( " + this.point.benchmarkY.join(", ") + " )");

        if (this.point.lbase)
            labelValues.push("" + this.point.lbase + "");

        if (this.point.sigTestLabel) {
            if (this.point.sigTestResults && this.point.sigTestResults.length > 0) {
                var combinedColoredLabels = [];
                $(this.point.sigTestResults).each(function () {
                    combinedColoredLabels.push("<span style='color: " + this.color + "'>" + this.label + "</span>");
                });

                labelValues.push("(" + combinedColoredLabels.join(',') + ")");
            } else
                labelValues.push("" + this.point.sigTestLabel + "");
		}

        if (this.point.showLabels) {
            //add the series name first, with a following new line if
            //any other item has been added to array
            labelValues.splice(0, 0, this.series.name);
            if (labelValues.length > 1)
                labelValues.splice(1, 0, "<br/>");
        }

        var formattedDataLabel = labelValues.join(" ");

        if (this.point.series.type == "treemap" && this.point.id) {
            return '<strong>' + formattedDataLabel + '</strong>';
        }

        return formattedDataLabel;
    }

    function tooltipFormatter() {
        var tooltipString = "";

        var pointSettings = this;
        var dataPoint = pointSettings.point;
        var series = pointSettings.series;
        var tooltipOptions = series.chart.userOptions.tooltip;

        var xAxisOpt = !series.xAxis ? {} : series.xAxis.options;
        var yAxisOpt = !series.yAxis ? {} : series.yAxis.options;
        var legendLabel;
        if (series.type === "pie") {
            xAxisOpt = series.chart.userOptions.xAxis[0];
            yAxisOpt = series.chart.userOptions.yAxis[0];
        }

        // Header text = Axis label + Legend label (if on and not empty)
        // scatter has values on Axis, do not add it
        if (series.type !== "scatter" && tooltipOptions.showAxisLabel) {
            if (series.type === "pie")
                tooltipString = series.options.name;
            else if (series.type === "treemap")
                tooltipString = dataPoint.parentName || '';
            else if (series.type === "heatmap")
                tooltipString = pointSettings.key || '';
            else {                
                tooltipString = typeof pointSettings?.x === "string"
                    ? pointSettings.x
                    : typeof pointSettings?.x?.name === "string"
                        ? pointSettings.x.name
                        : "";
            }                
        }

        if (tooltipOptions.showLegendLabel) {
            // pies and donuts: legend label is point name
            if (series.type === "pie")
                legendLabel = pointSettings.key;
            else if (series.type === "treemap")
                legendLabel = dataPoint.name;
            else
                legendLabel = series.options.name;

            legendLabel = legendLabel || "";
            if (legendLabel !== "")
                tooltipString += (tooltipString === "" ? "" : " - ") + legendLabel;
        }
        
        if (tooltipString !== "") {
            tooltipString = "<span>" + tooltipString + "</span><br/>";
            // add color marker for scatter
            if (series.type === "scatter")
                tooltipString = "<span style=\"color:" + dataPoint.color + "\">\u25CF </span>" + tooltipString;
        }

        var py;
        if (series.type === "treemap" || series.type === "heatmap")
            py = dataPoint.formattedValue;
        else if (dataPoint.sy != null){
            py = dataPoint.sy;
            if (yAxisOpt.unitPrefix && (dataPoint.showYUnitText || dataPoint.showYunitText))
                py = yAxisOpt.unitPrefix + py;
            else if (yAxisOpt.unitSuffix && (dataPoint.showYUnitText || dataPoint.showYunitText))
                py = py + yAxisOpt.unitSuffix;
        }

        function getExtraDPInfoItem(value, header) {
            if (value) {
                var valueStr = Highcharts.numberFormat(value, null, decimalSeparator, showThousandSeparator ? thousandSeparator : "");
                return locale.get(header) + "<b>" + valueStr + "</b><br/>";
            }
            return '';
        }

        function getExtraDPInfo(wBase, nwBase, resp) {
            return getExtraDPInfoItem(wBase, "Weighted base:") +
                getExtraDPInfoItem(nwBase, "Unweighted base:") +
                getExtraDPInfoItem(resp, "Respondents:");
		}

        var showThousandSeparator = series.options.showThousandSeparator;
        // Values block, use sx, sy ans sz, they are already formatted
        if (series.type !== "scatter") {
            tooltipString += py != null ? ("<b>" + py + "</b><br />") : "";

            tooltipString += getExtraDPInfo(dataPoint.wbase, dataPoint.nwbase, dataPoint.resp);
        } else {
            // special case for scatter: show x, y and if exists - z
            var px = dataPoint.sx;
            if (xAxisOpt.unitPrefix && dataPoint.showXUnitText)
                px = xAxisOpt.unitPrefix + px;
            else if (xAxisOpt.unitSuffix && dataPoint.showXUnitText)
                px = px + xAxisOpt.unitSuffix;

            var extraInfo = getExtraDPInfo(dataPoint.wbaseX, dataPoint.nwbaseX, dataPoint.respX);
            var addBreaks = extraInfo.length > 0;

            tooltipString += "x: <b>" + px + (dataPoint.pxSuffix || "") + "</b><br />";
            tooltipString += extraInfo; 

            if (py != null) {
                if (addBreaks)
                    tooltipString += '<span style="visibility: hidden;">-</span><br />'; // hidden span - highcharts doesn't work with <br/><br/>
                tooltipString += "y: <b>" + py + (dataPoint.pySuffix || "") + "</b><br />";
                tooltipString += getExtraDPInfo(dataPoint.wbase, dataPoint.nwbase, dataPoint.resp);
			}

            if (dataPoint.z) {
                if (addBreaks)
                    tooltipString += '<span style="visibility: hidden;">-</span><br />';
                tooltipString += "z: <b>" + dataPoint.sz + (dataPoint.szSuffix || "") + "</b><br />";
                tooltipString += getExtraDPInfo(dataPoint.wbaseZ, dataPoint.nwbaseZ, dataPoint.respZ);
            }
        }

		if (dataPoint.showSigTestValuesInTooltip) {
			if (typeof (dataPoint.s1) != 'undefined' && dataPoint.s1 != null)
				tooltipString += locale.get("Standard deviation S1=") + "<b>" +
					Highcharts.numberFormat(dataPoint.s1, decimalPlaces(dataPoint.s1), decimalSeparator, showThousandSeparator ? thousandSeparator : "") + "</b><br/>";

			if (typeof (dataPoint.s2) != 'undefined' && dataPoint.s2 != null)
				tooltipString += locale.get("Standard deviation S2=") + "<b>" +
					Highcharts.numberFormat(dataPoint.s2, decimalPlaces(dataPoint.s2), decimalSeparator, showThousandSeparator ? thousandSeparator : "") + "</b><br/>";

			if (typeof (dataPoint.T) != 'undefined')
				tooltipString += locale.get("T-value=") + "<b>" +
					Highcharts.numberFormat(dataPoint.T, decimalPlaces(dataPoint.T), decimalSeparator, showThousandSeparator ? thousandSeparator : "") + "</b><br/>";

			if (typeof (dataPoint.degreesOfFreedom) != 'undefined')
				tooltipString += locale.get("Degrees of freedom=") + "<b>" +
					Highcharts.numberFormat(dataPoint.degreesOfFreedom, null, decimalSeparator, showThousandSeparator ? thousandSeparator : "") + "</b><br/>";

			if (typeof (dataPoint.criticalValue) != 'undefined')
				tooltipString += locale.get("Critical value=") + "<b>" +
					Highcharts.numberFormat(dataPoint.criticalValue, decimalPlaces(dataPoint.criticalValue), decimalSeparator, showThousandSeparator ? thousandSeparator : "") + "</b><br/>";
		}

        return tooltipString;
    }

    function resetChartStyleControls() {
        setDefaultOptions();
        var hc = { defaultStyles: defaultStyles };
        Storyboard.HighchartsWrapper.Helpers.parseTheme(hc.defaultStyles, []);
    }


    function getExportOptions(detailTables, chartOptions) {
        var tempMenuItems = getExportMenuItems(detailTables, chartOptions);
        return {
            enabled: !(tempMenuItems.every(function (i) { return i === null; })),
            buttons: {
                exportButton: {
                    menuItems: tempMenuItems
                }
            }
        };
    }

    function getExportMenuItems(detailTables, chartOptions) {
        //add new option magnifying glass - we need to check chartOptions object and also support custom code
        var exportOptions = chartOptions.chartExportSettings ? chartOptions.chartExportSettings : chartOptions;

        //highcharts has four fixed slots that needs to be filled, otherwise built-in export options will be shown
        var menuItems = Array(4);
        var menuIndex = 0, dt, dtIndex = 0, opt, optIndex = 0;
        for (; menuIndex < 4; menuIndex++)
            menuItems[menuIndex] = null;

        menuIndex = 0;

        if (typeof chartOptions.showMagnifyingGlass !== 'boolean' || chartOptions.showMagnifyingGlass === true) {
            menuItems[menuIndex++] = {
                text: '<div class="highcharts-export-menu-item highcharts-export-menu-item-zoom"><img src="icons/zoom-in.png" title="' + locale.get('Show enlarged chart') + '"/></div>',
                onclick: function (evt) {
                    Storyboard.HighchartsWrapper.callbackShowChart(this)
                    return false;
                }
            };
        }

        if ((Storyboard.LayoutDesigner.isAdmin && !Helpers.isPreview()) || (exportOptions && exportOptions.length > 0 && exportOptions[0].disabled != true) || !exportOptions) {

            if (menuIndex > 0)
                menuItems[menuIndex++] = {
                    text: '<div class="highcharts-export-menu-hr"></div>',
                    onclick: function (evt) {
                        return false;
                    }
                };

            var chartlaboptions = Storyboard.ChartLab.parts;

            for (; optIndex < 5; optIndex++) {
                opt = chartlaboptions[optIndex];
                var displayOption = true;
                if (opt == 'Time periods') {
                    var ofFloatingTimePeriodSelection = $('select[id="Floating time period"] > option:selected');
                    var ofIntervalSelection = $('#Interval > option:selected');
                    var ofMovingAverageSelection = $('select[id="Moving Average"] > option:selected');

                    if (ofFloatingTimePeriodSelection.length > 0 && ofIntervalSelection.length > 0 && ofMovingAverageSelection.length > 0)
                        displayOption = false;
                }

                if (displayOption && Storyboard.ChartLab.checkPartAvailable(opt, exportOptions)) {
                    menuItems[menuIndex++] = {
                        text: '<div class="highcharts-export-menu-item highcharts-export-menu-item-filter"><img src="' + Storyboard.ChartLab.partIcons[optIndex] + '" title="' + opt + '"/></div>',
                        onclick: function (evt) {
                            var guid;
                            if (evt != null) {
                                guid = $(evt.target).parentsUntil('.layoutElement').parent().attr('guid');
                            } else {
                                evt = event;
                                guid = $(evt.srcElement).parentsUntil('.layoutElement').parent().attr('guid');
                            }
                            Storyboard.ChartLab.load(evt, guid);
                            return false;
                        }
                    };
                }
            }
        }

        if (detailTables && detailTables.length > 0) {
            menuItems[menuIndex++] = {
                text: '<div class="highcharts-export-menu-hr"></div>',
                onclick: function (evt) {
                    return false;
                }
            };
        }

        if (detailTables && detailTables.length > 0) {
            menuItems[menuIndex++] = {
                text: (function () {
                    var r = [];
                    r.push('<div class="highcharts-export-menu-item highcharts-export-menu-item-drilldown">');
                    r.push('<img src="icons/drilldown.png" title="' + locale.get('Drilldown') + '"/>');
                    r.push('<ul>');

                    for (; dtIndex < detailTables.length; dtIndex++) {
                        dt = detailTables[dtIndex];
                        r.push('<li title="' + locale.get('Drilldown') + ': ' + dt.name + '">' + dt.name + '</li>');
                    }

                    r.push('</ul>');
                    r.push('</div>');

                    return r.join('')
                })(),
                onclick: function (evt) {
                    var detailTable;
                    if (evt != null) {
                        detailTable = detailTables[$(evt.target).index()];
                    } else {
                        evt = event;
                        detailTable = detailTables[$(evt.srcElement).index()];
                    }
                    Storyboard.HighchartsWrapper.callbackShowDetailTable(detailTable.tableId, this.options.chart.guid);
                    return false;
                }
            }
        }
        return menuItems;
    }

    function fixHtmlEntities(chartOptions, chartDiv) {
        for (var i = 0, series; (series = chartOptions.series[i]); i++) {
            series.name = replaceHtmlEntities(series.name);

            for (var dpi = 0, dp; (dp = series.data[dpi]); dpi++) {
                dp.name = replaceHtmlEntities(dp.name);
                dp.lbase = replaceHtmlEntities(dp.lbase);

                if (typeof (chartsExcludedFromLowBaseMarkerHiding) !== 'undefined') {

                    var chartID = $(chartDiv).parent('div').attr('layoutElementId');

                    if ($.inArray(chartID, chartsExcludedFromLowBaseMarkerHiding) === -1) {
                        dp.lbase = '';
                    }
                }
            }
        }

        if (chartOptions.xAxis && chartOptions.yAxis) {
            var allAxes = chartOptions.xAxis.concat(chartOptions.yAxis);
            for (var xi = 0, axis; (axis = allAxes[xi]); xi++) {

                //fix categories texts
                for (var ci = 0; axis.categories && ci < axis.categories.length; ci++)
                    axis.categories[ci] = replaceHtmlEntities(axis.categories[ci]);

                allAxes[xi].unitPrefix = replaceHtmlEntities(allAxes[xi].unitPrefix);
                allAxes[xi].unitSuffix = replaceHtmlEntities(allAxes[xi].unitSuffix);

                if (allAxes[xi].title)
                    allAxes[xi].title.text = replaceHtmlEntities(allAxes[xi].title.text);
            }
        }

        for (var m = 0; chartOptions.warning.warningTexts && m < chartOptions.warning.warningTexts.length; m++)
            chartOptions.warning.warningTexts[m] = replaceHtmlEntities(chartOptions.warning.warningTexts[m]);

        if (chartOptions.title)
            chartOptions.title.text = replaceHtmlEntities(chartOptions.title.text);
        if (chartOptions.subtitle)
            chartOptions.subtitle.text = replaceHtmlEntities(chartOptions.subtitle.text);
    }

    function replaceHtmlEntities(str) {
        if (!str) return str;

        str = str.replace(/</g, '&lt;').replace(/>/g, '&gt;');

        return str;
    }

    function setPointFormat(pointFormat) {
        if (pointFormat && pointFormat.DecimalSeparator)
            decimalSeparator = pointFormat.DecimalSeparator;
        else
            decimalSeparator = "."

        if (pointFormat && pointFormat.ThousandSeparator)
            thousandSeparator = pointFormat.ThousandSeparator;
        else
            thousandSeparator = " ";
    }

    function produceChart(chartDiv, chartOptions, guid, isRegularChart, detailTables, styles, userEvents) {
        fixHtmlEntities(chartOptions, chartDiv);
        setPointFormat(chartOptions.pointFormat);

        //if first xAxis category or any series is containing arabic letters then we are setting arabic settings
        var rtlCharacters = /[\u0591-\u07FF\uFB1D-\uFDFD\uFE70-\uFEFC]/;
        var isRTLCharsXAxis = false;
        var isRTLCharsLegend = false
        if (!chartOptions.xAxis || chartOptions.xAxis[0].categories == null)
            setDefaultOptions(false);
        else {
            $.each(chartOptions.xAxis[0].categories, function (index, value) {
                if (rtlCharacters.test(value)) {
                    isRTLCharsXAxis = true;
                    return false;
                }
            });
        }

        $.each(chartOptions.series, function (index, value) {
            if (rtlCharacters.test(value.name)) {
                isRTLCharsLegend = true;
                return false;
            }
        });

        setDefaultOptions(isRTLCharsXAxis, isRTLCharsLegend);

        if (chartOptions) {

            // run external method to modify chart content
            runExternalTransformations(chartDiv, chartOptions);

            for (var i = 0; i < chartOptions.series.length; i++) {
                /* need to make sure every properties on chartOptions are kept,
				so first apply defaultChartTypeSettings, then let the chartOptions override the things it needs */
                var seriesOptions = $.extend({}, defaultChartTypeSettings[chartOptions.series[i].type]);
                seriesOptions = $.extend(seriesOptions, chartOptions.series[i]);
                chartOptions.series[i] = seriesOptions;

                //apply animation from project settings if required   
                if (chartOptions.enableChartAnimation && chartOptions.durationOfChartAnimation >= 0 && typeof (sbChartAnimation) === 'undefined' && chartOptions.isStoryTellerOrDrilldownReport
                    && ((Storyboard.LayoutDesigner.isAdmin && Helpers.isPreview()) || (Storyboard.LayoutDesigner && !Storyboard.LayoutDesigner.isAdmin))) {
                    chartOptions.series[i].animation = { duration: parseInt(chartOptions.durationOfChartAnimation) };                  
                }

                // apply animation if required
                if (typeof (sbChartAnimation) != 'undefined') {
                    chartOptions.series[i].animation = { duration: parseInt(sbChartAnimation) };
                }

                // Center align datalabels for stacked barcharts
                if (chartOptions.series[i].stacking == 'normal' || chartOptions.series[i].stacking == 'percent') {
                    if (chartOptions.series[i].type === "treemap")
                        chartOptions.series[i].levels.forEach(function (level) { level.dataLabels.align = "center"; });
                    else
                        chartOptions.series[i].dataLabels.align = 'center';
                }

                var useColoredSigTest = false;
                for (var di = 0; di < chartOptions.series[i].data.length; di++) {
                    if (chartOptions.series[i].data[di].sigTestResults && chartOptions.series[i].data[di].sigTestResults.length > 0) {
                        useColoredSigTest = true;
                        break;
					}
                }
                if (useColoredSigTest)
                    chartOptions.series[i].dataLabels.useHTML = true;
            }

            // measure title and warnings elements
            var divId = typeof (chartDiv) == "string" ? "#" + chartDiv : chartDiv;
            chartOptions.title.measuredHeight = 0;
            chartOptions.warningsMeasuredHeight = 0;

            if (chartOptions.title.text) {
                var titleTestElem = $("<div>" + chartOptions.title.text + "</div>");
                titleTestElem.css('font-size', '9px');
                titleTestElem.css('width', chartOptions.warning.warningTexts.length > 0 ? '60%' : '90%');
                titleTestElem.css('line-height', '16px');
                $(divId).append(titleTestElem);

                chartOptions.title.width = titleTestElem.width();
                chartOptions.title.measuredHeight = titleTestElem.height();
            }
            
            if (chartOptions.warning.warningTexts.length > 0) {
                var warningTextArr = [];
                for (i = 0; i < chartOptions.warning.warningTexts.length; i++)
                    warningTextArr.push(chartOptions.warning.warningTexts[i]);
                var warningsTestElem = $("<div>" + warningTextArr.join(',') + "</div>");
                warningsTestElem.css('font-size', '9px');
                if (chartOptions.title.text)
                    warningsTestElem.css('width', $(divId).width() - 20 - chartOptions.title.width + "px");
                warningsTestElem.css('line-height', '16px');
                warningsTestElem.css('padding-right', '20px');
                $(divId).append(warningsTestElem);

                chartOptions.warningsMeasuredHeight = warningsTestElem.height();
            }
            chartOptions.chart.renderTo = chartDiv;
            guid = guid || chartOptions.chart.guid;
            setDependentOptions(chartOptions, isRegularChart, detailTables);
        } else
            chartOptions = {};


        if (styles) {
            var ignoredChartStyles = [];
            if (chartOptions.series[0] && sb.MarimekkoChart.isMarimekko(chartOptions.series[0]))
                ignoredChartStyles = sb.MarimekkoChart.getIgnoredChartStyles(chartOptions);
            var stylesToApply = styles.filter(function (style) { return ignoredChartStyles.indexOf(style.settingKey) === -1; });

            Storyboard.HighchartsWrapper.Helpers.overrideChartSpecificStyles(stylesToApply, chartOptions);
            Storyboard.HighchartsWrapper.Helpers.applyChartStyles(stylesToApply, chartOptions);
        }

        fixSolidGaugeThreshold(chartOptions);

        //Only for Advanced Analytics Charts
        var elem = Storyboard.LayoutDesigner.getLayoutElementByIdOrGuid($(chartDiv).parent('div').attr('id')) ||
            Storyboard.LayoutDesigner.getLayoutElementByIdOrGuid($(chartDiv).parent('div').attr('layoutelementid'));
        if ((elem !== null && Storyboard.LayoutDesigner.getLayoutElementType(elem) === Storyboard.Constants.itemTypes.ADVANCEDANALYTICS) || chartDiv === 'divAdvancedAnalytics') {
            if (chartOptions.subtitle) {
                //Position and apply filter text style to subtitle - filters are displayed in subtitle in AA if base info is shown
                chartOptions.subtitle.style = chartOptions.title.style;
                chartOptions.subtitle.align = chartOptions.title.align;
                chartOptions.subtitle.y = chartOptions.title.y + chartOptions.title.measuredHeight;

                //Apply base info style to title - base size info uses title
                chartOptions.title.style = chartOptions.warning.style;
            }
        }
        else {
            if (!chartOptions.legend.enabled)
                delete chartOptions.subtitle;
            if (chartOptions.subtitle && chartOptions.subtitle.text) {
                chartOptions.subtitle.style = chartOptions.legend.itemStyle;

                if (chartOptions.legend.verticalAlign == "top") {
                    // measure subtitle height and move legend to avoid overlapping
                    var subTitleTestElem = $("<div>" + chartOptions.subtitle.text + "</div>");
                    subTitleTestElem.css(chartOptions.subtitle.style);
                    $(divId).append(subTitleTestElem);
                    chartOptions.legend.y = subTitleTestElem.height();
                }
            }
        }

        if (chartOptions.title.text || chartOptions.warning.warningTexts.length > 0) {
            var mathMax;
            mathMax = parseInt(chartOptions.chart.spacingBottom) > 25 ? chartOptions.chart.spacingBottom : 25;
            chartOptions.chart.spacingBottom = Math.max(mathMax, chartOptions.title.measuredHeight, chartOptions.warningsMeasuredHeight);

            if (chartOptions.title.text) {
                chartOptions.title.align = "left";
                chartOptions.title.verticalAlign = "bottom";
			}
        }

        if (chartOptions.xAxis) {
            var xAxis = chartOptions.xAxis[0];
            if (xAxis && xAxis.labels && xAxis.labels.step == "auto")
                delete xAxis.labels.step;
        }

        // set scale angles to highcharts defaults for all charts except gauge
        if (chartOptions.series.length > 0 && chartOptions.series[0].type != "gauge" && chartOptions.series[0].type != "solidgauge" && chartOptions.pane) {
            delete chartOptions.pane.startAngle;
            delete chartOptions.pane.endAngle;
        }

        $(chartOptions.series).each(function () {
            if (this.type !== "line" && this.type !== "spline" && this.type !== "area" && this.type !== "treemap" && this.marker)
				delete this.marker.radius;

			if (this.color === null && this.data.length > 0 && this.data[0].color)
				this.color = 'transparent';
        });

        // remove properties to let highcharts use auto behavior
        if (chartOptions.pane && chartOptions.pane.background) {
            if (!chartOptions.pane.background.innerRadius)
                delete chartOptions.pane.background.innerRadius;
            if (!chartOptions.pane.background.outerRadius)
                delete chartOptions.pane.background.outerRadius;
            if (!chartOptions.pane.background.shape)
                delete chartOptions.pane.background.shape;
        }

        //override startOnTick setting. If either min scale or any value is below zero
        //to disable startOnTick to prevent showing negative scale for low (but positive) values
        var negAxes = [];
        for (var si = 0, s; (s = chartOptions.series[si]); si++) {
            if (chartOptions.yAxis) {
                var yAxis = s.yAxis || 0;
                if ((chartOptions.yAxis[yAxis].min || 0) < 0)
                    negAxes[yAxis] = true;

                for (var dj = 0, d; s.data && (d = s.data[dj]) ; dj++) {
                    if (d.y < 0)
                        negAxes[yAxis] = true;
                }

                chartOptions.yAxis[yAxis].startOnTick = !!negAxes[yAxis];
            }

            if (s.type == "bar" || s.type == "column" || s.type == 'columnrange') {
                // for stacked/fullStacked bar/column charts with middle label posiiton: use 0 padding
                if (s.stacking != null && s.dataLabels.align == "center")
                    s.dataLabels.padding = 0;

                if (chartOptions.autoColumnBarWidth || isNaN(s.pointWidth) || s.pointWidth <= 0)
                    s.pointWidth = null;
            }

            // for side-by-side area 0.75 opacity should be used
            if (s.type == "area" && s.stacking == null)
                chartOptions.plotOptions.area.fillOpacity = 0.75;
        }

        // apply custom settings, defined by external global variables, most likely set through skins and custom html
        var leid;
        if (typeof (excludeLegendExcept) != 'undefined') {
            if (guid == 'largeChart' && typeof (showLegendInZoomedChart) != 'undefined' && showLegendInZoomedChart)
                chartOptions.legend.enabled = true;
            else {
                leid = $(chartDiv).parent('div').attr('layoutElementId');
                if ($.inArray(leid, excludeLegendExcept) == -1)
                    chartOptions.legend.enabled = false;
            }
        }
        else if (typeof (excludeLegend) != 'undefined') {
            if (guid == 'largeChart' && typeof (showLegendInZoomedChart) != 'undefined' && showLegendInZoomedChart)
                chartOptions.legend.enabled = true;
            else {
                leid = $(chartDiv).parent('div').attr('layoutElementId');
                if ($.inArray(leid, excludeLegend) > -1)
                    chartOptions.legend.enabled = false;
            }
        }

        if (typeof (chartsExcludedFromLowBaseMarkerHiding) !== 'undefined') {

            leid = $(chartDiv).parent('div').attr('layoutElementId');

            if ($.inArray(leid, chartsExcludedFromLowBaseMarkerHiding) === -1) {
                $.each(chartOptions.xAxis, function () {
                    var currentCategories = $(this)[0].categories;
                    $.each(currentCategories, function (index, item) {
                        var currentCategory = $(this);
                        currentCategories[index] = currentCategory[0].replace(/\*/g, '');
                    });
                });

                $.each(chartOptions.series, function () {
                    $(this)[0].name = $(this)[0].name.replace(/\*/g, '');
                });
            }
        }

        // adjust export button Y coordinate to account for top spacing (it's 23px and needs to be outside chart area)
        if (chartOptions.exporting)
			chartOptions.exporting.buttons.exportButton.y = -(chartOptions.chart.spacingTop + 23);

		if (userEvents && chartDiv != 'divChart') {
			var element = $(chartDiv).parent('div')[0];
			chartOptions.plotOptions.series = $.extend(chartOptions.plotOptions.series, { point: { events: {} } });
			Storyboard.LayoutDesigner.UserEvents.addEventsToChart(element, chartOptions, userEvents);
		}

        // end custom settings
        hiddenSeries(chartDiv, chartOptions);
        redrawCharts(guid, chartDiv, chartOptions);
    }

    function fixSolidGaugeThreshold(chartOptions) {
        if (chartOptions.dataGroupVersion >= 7 && // version 7 - threshold in solid gauge 
            chartOptions.series.length > 0 && chartOptions.series[0].type == "solidgauge" && (chartOptions.series[0].threshold || chartOptions.series[0].threshold == 0)) {
            delete chartOptions.series[0].dial;
            delete chartOptions.series[0].negativeColor;

            var value = chartOptions.series[0].data[0].y;
            var threshold = chartOptions.series[0].threshold;

            var newPoint = {
                x: 0,
                color: chartOptions.pane.background.backgroundColor,
                sy: chartOptions.series[0].data[0].sy
            };

            if (value > threshold)
                newPoint.y = threshold;
            else {
                newPoint.y = chartOptions.series[0].data[0].y;
                chartOptions.series[0].data[0].y = threshold;
            }

            chartOptions.series[0].data.push(newPoint);
        }
    }

    function runExternalTransformations(chartDiv, chartOptions) {
        try {
            if (typeof (customChartTransformationArray) != 'undefined'
                && typeof (customChartTransformationMethod) == 'function') {
                var leid = $(chartDiv).parent('div').attr('layoutElementId');
                if ($.inArray(leid, customChartTransformationArray) != -1) {
                    customChartTransformationMethod(chartOptions);
                }
            }
        } catch (err) { /* empty */ }
    }
    function hiddenSeries(chartDiv, chartOptions) {
        var le = Storyboard.LayoutDesigner.getLayoutElementByIdOrGuid($(chartDiv).parent('div').attr('id')) ||
            Storyboard.LayoutDesigner.getLayoutElementByIdOrGuid($(chartDiv).parent('div').attr('layoutelementid'));
        if (!le) return;

        // apply hidden series on initial load, either from element or returned from server 
        var currentlyExcluded = le.hiddenChartSeries ||
            $.grep(chartOptions.series, function (n) { return !n.visible; }).map(function (s) { return s.nodePath; })
            || [];

        if (le.hiddenChartSeries && le.hiddenChartSeries.length > 0)
            $(chartOptions.series).each(function () {
                if (currentlyExcluded.indexOf(this.nodePath) > -1)
                    this.visible = false;
                else
                    this.visible = true;
            });
        else
            le.hiddenChartSeries = currentlyExcluded;

        if (chartOptions.plotOptions.series) {
            // set event for preserving hidden series
            chartOptions.plotOptions.series.events = {
                legendItemClick: function () {
                    // solidgauge is raw and stacking is implemented as a hack for now so hiding/showing does not work properly, disable it for now
                    if (window.ContentType == Storyboard.Constants.itemTypes.CHART || 
                        chartOptions.series[0].type == "solidgauge") {
                        return false;
                    }

                    var elem = Storyboard.LayoutDesigner.getLayoutElementByIdOrGuid($(chartDiv).parent('div').attr('id')) ||
                        Storyboard.LayoutDesigner.getLayoutElementByIdOrGuid($(chartDiv).parent('div').attr('layoutelementid'));

                    elem.hiddenChartSeries = elem.hiddenChartSeries || [];

                    if (!this.visible)
                        elem.hiddenChartSeries.splice($.inArray(this.userOptions.nodePath, elem.hiddenChartSeries), 1);
                    else
                        elem.hiddenChartSeries.push(this.userOptions.nodePath);

                    //console.log(elem.hiddenChartSeries);
                }
            };

			if (window.ContentType == Storyboard.Constants.itemTypes.CHART) {
					chartOptions.plotOptions.series.point = chartOptions.plotOptions.series.point || {};
					chartOptions.plotOptions.series.point.events = {
					legendItemClick: function () {
						return false;
					}
				}
			}
		}
	}

    function setDependentOptions(chartOptions, isRegularChart, detailTables) {
        if (!chartOptions.legend)
            chartOptions.legend = {};

        //avoid regression bug for polar. null value for min/max scale on x axis causes
        //series to disappear
        var xAxis;
        if (chartOptions.chart.polar && chartOptions.xAxis) {
            for (var i = 0; (xAxis = chartOptions.xAxis[i]); i++) {
                xAxis.min == null && delete xAxis.min;
                xAxis.max == null && delete xAxis.max;
            }
        }

        // something in highcharts does not merge defaultStyles properly when polar is used so we have to do it manually
        if (chartOptions.chart.polar && chartOptions.yAxis) {
            chartOptions.yAxis[0] = $.extend(chartOptions.yAxis[0], { labels: { formatter: defaultStyles.yAxis.labels.formatter } });
        }

        // limit tooltip boundaries if boundaries are defined in customhtml
        if (typeof (leftTooltipBoundary) != 'undefined' && parseInt(leftTooltipBoundary) >= 0) {
            chartOptions = $.extend(chartOptions,
                {
                    tooltip: {
                        positioner: function (boxWidth, boxHeight, point) {
                            var origPos = this.getPosition(boxWidth, boxHeight, point);
                            if (origPos.x < leftTooltipBoundary)
                                origPos.x = leftTooltipBoundary;
                            return origPos;
                        }
                    }
                });
        }

        if (chartOptions.plotOptions
            && chartOptions.plotOptions.series
            && !chartOptions.plotOptions.series.threshold)
            delete chartOptions.plotOptions.series.threshold;

        if (chartOptions.xAxis) {
            xAxis = chartOptions.xAxis[0];
            if (!xAxis.categories || xAxis.categories.length === 0)
                xAxis.labels = { enabled: false };
            else {
                var allEmpty = true;
                for (var categoryI = 0; categoryI < xAxis.categories.length; categoryI++)
                    if (xAxis.categories[categoryI] !== '') {
                        allEmpty = false;
                        break;
                    }
                xAxis.labels = $.extend(xAxis.labels, { enabled: !allEmpty });
            }
        }

        //force various axis settings for scatter otherwise the markers will be drawn outside the plot area
        if (chartOptions.series.length > 0 && chartOptions.series[0].type == 'scatter') {
            chartOptions.yAxis[0].startOnTick = true;
            chartOptions.xAxis[0].startOnTick = true;
            chartOptions.xAxis[0].endOnTick = true;
            chartOptions.xAxis[0].showLastLabel = true;
            chartOptions.xAxis[0].labels = { enabled: true };
        }

        var series
        // force 0 (or negative) min for gauge chart, auto-scaling for this type is different and scale values may be weird
        if (chartOptions.series.length > 0 && (chartOptions.series[0].type == "gauge" || chartOptions.series[0].type == "solidgauge") && !chartOptions.yAxis[0].min) {
            var gaugeMin = 0;
            for (seriesX = 0; seriesX < chartOptions.series.length; seriesX++) {
                series = chartOptions.series[seriesX];
                for (pointX = 0; pointX < series.data.length; pointX++) {
                    gaugeMin = gaugeMin < series.data[pointX].y ? gaugeMin : series.data[pointX].y;
                }
            }
            if (gaugeMin < 0) gaugeMin -= 0.5;
            chartOptions.yAxis[0].min = gaugeMin;
        }

        /* hack for case 14068. If series color is unset and only one data point exists, use the point color as series color */
        var seriesX, pointX, cmpColor;
        for (seriesX = 0; seriesX < chartOptions.series.length; seriesX++) {
            if (!(series = chartOptions.series[seriesX]).color) {

                for (pointX = 0; pointX < series.data.length; pointX++) {
                    /* if any of the points has a deviating color, the series color shall not be set */
                    if (cmpColor && cmpColor !== series.data[pointX].color) {
                        cmpColor = null;
                        break;
                    }

                    cmpColor = series.data[pointX].color;
                }

                series.color = cmpColor;
            }
        }

        if (isRegularChart) {
            chartOptions.exporting = Storyboard.HighchartsWrapper.getExportOptions(detailTables, chartOptions);
        } else
            delete chartOptions.exporting;
    }

    function destroyCharts(optionalGuid) {
        var handler;
        for (handler = chartHandlers.length - 1; handler >= 0; handler--)
            if (!optionalGuid || chartHandlers[handler].options.chart.guid === optionalGuid) {
                chartHandlers[handler].destroy();
                chartHandlers.splice(handler, 1);
            }

        if (!optionalGuid)
            chartHandlers = [];
	}

	function getChartHandler(guid) {
		for (var handlerIx = chartHandlers.length - 1; handlerIx >= 0; handlerIx--)
			if (chartHandlers[handlerIx].options.chart.guid === guid) {
				return chartHandlers[handlerIx];
			}

		return null;
	}

    function redrawCharts(guid, chartDiv, chartOptions) {
        // ---------------

        var handler;
        var chartOpt;
        var chartFound = false;
        var markerEnabled = false;

        if (chartOptions.colorAxis && chartOptions.colorAxis.stops) {
            chartOptions.colorAxis.startOnTick = false;
            chartOptions.colorAxis.endOnTick = false;
            chartOptions.colorAxis.stops.forEach(function (stop) {
                if (stop[1].indexOf('#') === -1)
                    stop[1] = Helpers.convertFromDecimalToHex(stop[1]);
            });
        }

        if (chartOptions.series[0] && chartOptions.series[0].type == "treemap") {
            chartOptions.legend.symbolWidth = undefined;
            if (!chartOptions.series[0].borderWidth) chartOptions.series[0].levels[0].borderWidth = 3;
            else chartOptions.series[0].levels[0].borderWidth = chartOptions.series[0].borderWidth * 3;

            ["xAxis", "yAxis"].forEach(function (e) { delete chartOptions[e]; });

            // Remove all empty objects in treemap series
            Storyboard.HighchartsWrapper.Helpers.removeEmptyFields(chartOptions.series[0]);

            // Allow drill to node only in preview mode
            if ((Storyboard.LayoutDesigner && !Storyboard.LayoutDesigner.isAdmin)
                || Helpers.isPreview()) {
                chartOptions.series[0].allowDrillToNode = true;
            } else {
                chartOptions.series[0].allowDrillToNode = false;
            }
        }

        if (chartOptions.series[0] && chartOptions.series[0].type == "heatmap") {
            // symbolWidth value is shrinking color strip
            chartOptions.legend.symbolWidth = undefined;

            // legend enabled = false is causing issues with dynamic coloring in HC v4.1.4 heatmaps
            if (chartOptions.legend && !chartOptions.legend.enabled) {
                chartOptions.legend.enabled = true;
                chartOptions.legend.padding = -1000;
            }

            // Remove all empty objects in heatmap series
            Storyboard.HighchartsWrapper.Helpers.removeEmptyFields(chartOptions.series[0]);

            // lineWidth is making issues in heat maps
            delete chartOptions.series[0].lineWidth;
        }

        if (chartOptions.series[0] && sb.MarimekkoChart.isMarimekko(chartOptions.series[0])) {
            // Remove ticks from xAxis
            chartOptions.xAxis[0].tickWidth = 0;

            // Add space above chart in order for share values to fit in
            chartOptions.chart.spacingTop = parseInt(chartOptions.series[0].dataLabels.style.fontSize) + 5;
        }

        var elem = Storyboard.LayoutDesigner.getLayoutElementByIdOrGuid($(chartDiv).parent('div').attr('id')) ||
            Storyboard.LayoutDesigner.getLayoutElementByIdOrGuid($(chartDiv).parent('div').attr('layoutelementid'));
        if ((elem !== null && Storyboard.LayoutDesigner.getLayoutElementType(elem) === Storyboard.Constants.itemTypes.ADVANCEDANALYTICS) || chartDiv === 'divAdvancedAnalytics') {
            var xAxis = chartOptions.xAxis[0];
            if (xAxis.groupedCategories && xAxis.groupedCategories !== null && xAxis.groupedCategories.length > 0) {
                xAxis.categories = xAxis.groupedCategories;
            }
        }

        // hardcode some styles for solid gauge
        // because setting them onSeriesTypeChanged may mess things up 
        // (for example if user selected solid gauge accidentally, then these will have to be reset manually)
        if (chartOptions.series[0] && chartOptions.series[0].type == "solidgauge") {
            chartOptions.xAxis[0].lineWidth = 0;
            chartOptions.xAxis[0].labels.enabled = false;
            chartOptions.yAxis[0].lineWidth = 0;
            chartOptions.yAxis[0].labels.enabled = false;
            chartOptions.yAxis[0].tickWidth = 0;
			chartOptions.yAxis[0].minorTickWidth = 0;
			if (!chartOptions.yAxis[0].plotBands)
				chartOptions.yAxis[0].plotBands = [];
        }

		if (chartOptions.series[0] && chartOptions.series[0].type == "gauge" && !chartOptions.yAxis[0].plotBands) {
			chartOptions.yAxis[0].plotBands = [];
		}

        for (var i = 0; i < chartOptions.series.length; i++) {
            if (chartOptions.series[i].dataLabels && chartOptions.series[i].dataLabels.color == 'rgba(255, 255, 255, 0.001)')
                chartOptions.series[i].dataLabels.enabled = false;

            if (chartOptions.series[i].color == 'rgba(255, 255, 255, 0.1)') {
                chartOptions.series[i].borderColor = 'rgba(255, 255, 255, 0.1)';
                chartOptions.series[i].dataLabels.enabled = false;
                chartOptions.series[i].borderWidth = 0;
                chartOptions.series[i].border = 0;
                chartOptions.series[i].shadow = false;

                chartOptions.tooltip = false;
            }

            if (chartOptions.series[i].borderColor == "rgba(255, 255, 255, 0.001)") {
                chartOptions.series[i].borderWidth = 0;
                chartOptions.series[i].border = 0;
                chartOptions.series[i].shadow = false;
            }

            if ((chartOptions.series[i].type == "line" || chartOptions.series[i].type == "spline") && chartOptions.series[i].lineWidth == 0) {
                chartOptions.series[i].shadow = false;
                chartOptions.series[i] = $.extend(chartOptions.series[i], { states: { hover: { enabled: false } } });
            }

            if (chartOptions.series[i].negativeColor) {
                for (var j = 0; j < chartOptions.series[i].data.length; j++) {
                    delete chartOptions.series[i].data[j].color;
                    delete chartOptions.series[i].data[j].negativeColor;
                }
            }

            if (!chartOptions.series[i].threshold) delete chartOptions.series[i].threshold;
            if (chartOptions.series[i].marker && chartOptions.series[i].marker.enabled) markerEnabled = true;

            if (chartOptions.series[i].dataLabels) {
                // delete distance property
                if (chartOptions.series[i].type != 'pie' || chartOptions.series[i].dataLabels.distance == 'null')
                    delete chartOptions.series[i].dataLabels.distance;
                else { // or set default - important for pie charts created before fix
                    chartOptions.series[i].dataLabels.distance = -30;
                    chartOptions.series[i].size = "100%";
                }
            }

            if (chartOptions.series[i].type === 'treemap'
                || (chartOptions.series[i].type != 'pie' && chartOptions.series[i].name == ""))
                chartOptions.series[i].showInLegend = false;

            if (chartOptions.series[i].type == "pie" && chartOptions.series[i].data.length > 0) {
                chartOptions.series[i].showInLegend = false;
                for (var dataI = 0; dataI < chartOptions.series[i].data.length; dataI++)
                    if (chartOptions.series[i].data[dataI].name !== "") {
                        chartOptions.series[i].showInLegend = true;
                        break;
                    }
            }

            if (chartOptions.series[i].type == "solidgauge" && chartOptions.series.length > 1 && chartOptions.series[i].dataLabels.enabled)
                chartOptions.series[i].dataLabels.zIndex = 7;
        }
        // sometimes markers get messed up in zoom (25632), but they're enabled/disabled for ALL series in a chart
        // so we can safely enable it if at least one series has marker.enabled = true
        if (markerEnabled && chartOptions.series.length > 0)
            $.each(chartOptions.series, function () { this.marker.enabled = true; });

        // code to add scroll to charts, two variables (enableScroll and scrollCharts) have to be defined in CustomHTML for code to work
        if (typeof (enableScroll) != 'undefined' && enableScroll && typeof (scrollCharts) != 'undefined' && scrollCharts.length > 0 &&
            chartOptions.series.length > 0 && (Storyboard.LayoutDesigner && !Storyboard.LayoutDesigner.isAdmin)) {
            var targetLayoutElement = parseInt($(chartDiv).parent().attr('layoutElementId'));
            // check if chart should have scroll
            for (var ix = 0; ix < scrollCharts.length; ix++)
                // only add scroll if chart has more data rows than what it is configured to handle
                if (scrollCharts[ix].id == targetLayoutElement && chartOptions.series[0].data.length > scrollCharts[ix].rows) {

                    var height = $(chartDiv).height();
                    var mult = chartOptions.series[0].data.length / scrollCharts[ix].rows;
                    var newHeight = ($(chartDiv).height() * mult);
                    $(chartDiv).css('height', newHeight + 'px');

                    var wrapperId = 'wrapper_' + $(chartDiv).attr('id');
                    var newDiv = $('<div class="chartScroll" id="' + wrapperId + '"></div>').attr('style', $(chartDiv).attr('style'));
                    newDiv.css('height', height + 'px').css('overflow-y', 'auto').css('overflow-x', 'hidden');
                    $(chartDiv).wrap(newDiv);
                }
        }

        chartOptions.series.forEach(function (s) {
            if (sb.MarimekkoChart.isMarimekko(s)) {
                // marimekko chart does not have padding between bars
                s.pointPadding = 0;
                s.groupPadding = 0;
            }
         
        });

        chartOptions.series.forEach(function (s) {
            var dls = s.dataLabels;

            if (s.dataLabels && s.type === 'bar') {
                // fix label alignments
                if (chartOptions.chart.invertChart && chartOptions.dataGroupVersion >= 12) {
                    if (dls.align === 'right') {
                        dls.align = 'right';
                        dls.inside = false
                    } else if (dls.align === 'left') {
                        dls.align = 'right';
                        dls.inside = true
                    } else if (dls.align === 'center')
                        dls.inside = true;
                    
                }
            }
            //FVPROD-157
            if (chartOptions.chart.invertChart) {
                s.data.forEach(function (a) {
                    if (a.y == 0 && s.threshold == null) {
                        a.color = 'transparent';
                    }
                })
            }
        });

        function chartCreationComplete(chart) {
            if (chart.series && chart.series.length > 0
                && chart.series[0].data && chart.series[0].data.length > 0
                && chart.series[0].data[0].showValues
                && sb.MarimekkoChart.isMarimekko(chart.series[0]))
                sb.MarimekkoChart.renderShareValues(chart);

            if (chart.series && chart.series.length > 0 && chart.series[0].userOptions && chart.series[0].userOptions.dataLabels &&
                chartOptions.series && chartOptions.series.length > 0 && chartOptions.series[0].dataLabels && !chartOptions.series[0].dataLabels.distance)
                delete chart.series[0].userOptions.dataLabels.distance

			Storyboard.HighchartsWrapper.Helpers.chartCreationComplete(chart, chartOptions.chart.invertChart, chartOptions.dataGroupVersion);
			Storyboard.HighchartsWrapper.Helpers.fixHeaderFooter($(chartDiv));
        }

        function fixLabels(chart) {
            Storyboard.HighchartsWrapper.Helpers.fixLabels(chart, chartOptions.chart.invertChart, chartOptions.dataGroupVersion);
        }

        function redrawQuadrants(chart) {
            Storyboard.HighchartsWrapper.Helpers.redrawColorQuadrants(chart);
		}

        for (handler = 0; handler < chartHandlers.length; handler++) {
            chartOpt = chartHandlers[handler].options;
            if (guid && chartOpt.chart.guid === guid) {
                chartHandlers[handler].destroy();
                chartOpt = chartOptions || chartOpt;
                chartOpt.chart.renderTo = chartDiv;

                if (!chartOpt.chart.events || !chartOpt.chart.events.redraw)
                    chartOpt.chart.events = $.extend(chartOpt.chart.events, { redraw: function () { fixLabels(this); redrawQuadrants(this); } });
                chartHandlers[handler] = new Highcharts.Chart(chartOpt, chartCreationComplete);
                chartFound = true;
                break;
            }
        }

        //if we got here, no chart handler was found
        if (chartOptions && chartFound == false) {
            for (var k = 0; k < chartOptions.series.length; k++) {
                if (chartOptions.series[k].color == 'rgba(255, 255, 255, 0.1)') {
                    chartOptions.series[k].borderColor = 'rgba(255, 255, 255, 0.1)';
                    chartOptions.series[k].dataLabels.enabled = false;
                    chartOptions.series[k].borderWidth = 0;
                    chartOptions.series[k].border = 0;
                    chartOptions.series[k].shadow = false;

                    chartOptions.tooltip = false;
                }

                if (chartOptions.series[k].negativeColor) {
                    for (var l = 0; l < chartOptions.series[k].data.length; l++) {
                        delete chartOptions.series[k].data[l].color;
                        delete chartOptions.series[k].data[l].negativeColor;
                    }
                }

            }
            if (!chartOptions.chart.events || !chartOptions.chart.events.redraw)
                chartOptions.chart.events = $.extend(chartOptions.chart.events, { redraw: function () { fixLabels(this); redrawQuadrants(this); } });
            var chart = new Highcharts.Chart(chartOptions, chartCreationComplete);
            chartHandlers.push(chart);
        }
        //for (var i = 0; i < chartOptions.series.length; i++) {
        //    if (chartOptions.series[0].type != 'treemap' && chartOptions.series[0].type != 'heatmap' && chartOptions.series[0].type != 'marimekko' &&
        //        chartOptions.chart.isValueBasedColoring == true) {
        //        var length = chartOptions.series.length;
        //        if (chartOptions.series[0].type == 'pie' || chartOptions.series[0].type == 'donut')
        //            length = chartOptions.series[0].data.length;
        //        for (var i = 0; i < length; i++) {
        //            if ($(".highcharts-legend-item").find('rect')[0] != null)
        //                $(".highcharts-legend-item").find('rect')[0].remove();

        //            else if ($(".highcharts-legend-item").find('path')[0] != null)
        //                $(".highcharts-legend-item").find('path')[0].remove();

        //        }
        //    }
        //}	
        //$(chartDiv).css('background-image', 'none');
        //$(chartDiv).css('background-color', 'transparent');

        /* layoutDesigner doesn't exists in export. Avoid crash*/
        if (Storyboard.LayoutDesigner && $(chartDiv).attr("id") != "Preview" && $(chartDiv).attr("id") != "largeChartContainer") {
            if (Storyboard.LayoutDesigner.isAdmin || window.ContentType == Storyboard.Constants.itemTypes.CHART) {
                $('.highcharts-container', $(chartDiv)).click(function (evt) {
                    if ($('.highcharts-export-menu:visible', chartDiv).length == 0)
                        Storyboard.GuiEvents.clickInContentbox(evt);
                });
            }
            else {
                $('.highcharts-container, .stExportToExcel, .stExportToCSV', $(chartDiv))
                    .bind('mouseover', function (evt) {
                        $(".highcharts-button", $(chartDiv)).each(function () {
                            if ($("title", this).length > 0 && $("title", this).text() == "Show chart options") {
                                $(this).trigger("onclick", evt);

                                if ($('.stExportToExcel, .stExportToCSV', $(chartDiv)).length > 0)
                                    $('.stExportToExcel, .stExportToCSV', $(chartDiv)).css("top", $('.highcharts-export-menu', $(chartDiv)).height());
                            }
                        });                        
                    })
                    .bind('mouseleave', function (evt) {
                        if ($('.highcharts-container:hover, .stExportToExcel:hover, .stExportToCSV:hover', $(chartDiv)).length > 0)
                            return;
                        var exportmenu = $('.highcharts-export-menu:visible', $(chartDiv));
                        if (exportmenu.length > 0) {
                            $(exportmenu).css({
                                'left': 'auto',
                                'right': '-14px',
                                'top': '-2px',
                                'display': 'none'
                            });
                        }
                    });
            }
        }
    }

    //expose functions
    sb.HighchartsWrapper = {
        getExportOptions: getExportOptions, /* public to be able to hide export buttons */
        produceChart: produceChart,
		destroyCharts: destroyCharts,
		getChartHandler: getChartHandler,
        redrawCharts: redrawCharts,
        defaultStyles: defaultStyles,
        setDefaultOptions: setDefaultOptions,
        resetChartStyleControls: resetChartStyleControls,
        callbackShowChart: null,
        callbackShowDetailTable: null
    };

})(window.Storyboard = (window.Storyboard || {}));